<div class="container-number">
  <mat-label>Container Number</mat-label>
  <form class="maineForm" [formGroup]="form" (copy)="onCopyMainForm($event)">
    <div formGroupName="ownerCode">
      <div class="custom-input-wrapper">
        <input #input1 class="custom-input" (paste)="onPasteFirstInputOfMainForm($event)" (keydown)="onKeyDown($event, input1)" autofocus type="text" formControlName="ownerCodeCharOne" [maxlength]="1" [minlength]="1"
              hmtAppAutoTab [hmtAppAutoTabInput]="input2">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input2 type="text" formControlName="ownerCodeCharTwo" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input2, input1)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input3">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input3 type="text" formControlName="ownerCodeCharThree" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input3, input2)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input4">
      </div>
    </div>
    <div class="custom-input-wrapper container-number-input">
      <input class="custom-input" #input4 type="text" formControlName="category" [maxlength]="1" [minlength]="1"
            (keydown)="onKeyDown($event, input4, input3)"
            hmtAppAutoTab [hmtAppAutoTabInput]="input5">
    </div>
    <div formGroupName="serialNumber">
      <div class="custom-input-wrapper container-number-input">
        <input class="custom-input" #input5 type="text" formControlName="digitOne" maxlength="1" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input5, input4)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input6">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input6 type="text" formControlName="digitTwo" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input6, input5)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input7">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input7 type="text" formControlName="digitThree" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input7, input6)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input8">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input8 type="text" formControlName="digitFour" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input8, input7)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input9">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input9 type="text" formControlName="digitFive" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input9, input8)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input10">
      </div>
      <div class="custom-input-wrapper">
        <input class="custom-input" #input10 type="text" formControlName="digitSix" [maxlength]="1" [minlength]="1"
              (keydown)="onKeyDown($event, input10, input9)"
              hmtAppAutoTab [hmtAppAutoTabInput]="input11">
      </div>
    </div>
    <div class="custom-input-wrapper container-number-input">
      <input class="custom-input" #input11 type="text" formControlName="checkDigit" [maxlength]="1" [minlength]="1"
            (keydown)="onKeyDown($event, input11, input10)"
            hmtAppAutoTab [hmtAppAutoTabInput]="reInput1">
    </div>
  </form>
  <div class="misMatch" *ngIf="isFormInValid()">
    <p>Container Number Validation is Invalid</p>
  </div>

  <mat-label>Retype Container Number</mat-label>
  <form class="maineForm" [formGroup]="retypeForm" (copy)="onCopyRetypeForm($event)">
    <div formGroupName="ownerCode">
      <div class="custom-input-wrapper">
        <input #reInput1 (paste)="onPasteFirstInputOfRetypeForm($event)" (keydown)="onKeyDown($event, reInput1)" 
               class="custom-input" [class.mismatch]="isRetypeFieldMismatch('ownerCode.ownerCodeCharOne', 'ownerCode.ownerCodeCharOne')"
               type="text" formControlName="ownerCodeCharOne" [maxlength]="1" [minlength]="1"
               hmtAppAutoTab  [hmtAppAutoTabInput]="reInput2">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput2 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('ownerCode.ownerCodeCharTwo', 'ownerCode.ownerCodeCharTwo')"
               type="text" formControlName="ownerCodeCharTwo" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput2, reInput1)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput3">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput3 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('ownerCode.ownerCodeCharThree', 'ownerCode.ownerCodeCharThree')"
               type="text" formControlName="ownerCodeCharThree" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput3, reInput2)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput4">
      </div>
    </div>
    <div class="custom-input-wrapper container-number-input">
      <input #reInput4 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('category', 'category')"
             type="text" formControlName="category" [maxlength]="1" [minlength]="1"
             (keydown)="onKeyDown($event, reInput4, reInput3)"
             hmtAppAutoTab [hmtAppAutoTabInput]="reInput5">
    </div>
    <div formGroupName="serialNumber">
      <div class="custom-input-wrapper container-number-input">
        <input #reInput5 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('serialNumber.digitOne', 'serialNumber.digitOne')"
               type="text" formControlName="digitOne" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput5, reInput4)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput6">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput6 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('serialNumber.digitTwo', 'serialNumber.digitTwo')"
               type="text" formControlName="digitTwo" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput6, reInput5)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput7">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput7 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('serialNumber.digitThree', 'serialNumber.digitThree')"
               type="text" formControlName="digitThree" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput7, reInput6)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput8">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput8 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('serialNumber.digitFour', 'serialNumber.digitFour')"
               type="text" formControlName="digitFour" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput8, reInput7)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput9">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput9 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('serialNumber.digitFive', 'serialNumber.digitFive')"
               type="text" formControlName="digitFive" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput9, reInput8)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput10">
      </div>
      <div class="custom-input-wrapper">
        <input #reInput10 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('serialNumber.digitSix', 'serialNumber.digitSix')"
               type="text" formControlName="digitSix" [maxlength]="1" [minlength]="1"
               (keydown)="onKeyDown($event, reInput10, reInput9)"
               hmtAppAutoTab [hmtAppAutoTabInput]="reInput11">
      </div>
    </div>
    <div class="custom-input-wrapper container-number-input">
      <input #reInput11 class="custom-input" [class.mismatch]="isRetypeFieldMismatch('checkDigit', 'checkDigit')"
             type="text" formControlName="checkDigit" [maxlength]="1" [minlength]="1"
             (keydown)="onKeyDown($event, reInput11, reInput10)">
    </div>
  </form>
  <div class="misMatch" *ngIf="isReTypeFormValid() && !matchingWithRetypeForm()">
    <mat-icon class="material-icons">warning</mat-icon><p>Container Number Validation Failed</p>
  </div>
</div>
